import React, { useState } from 'react';
import api from '../services/api';

function SignUpUser() {
    const [formData, setFormData] = useState({
        nome: '',
        tipo_negocio: '',
        localizacao: '',
        contato: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/empreendedores', formData);
            const data = await response.json();
            alert('Cadastro realizado com sucesso!');
        } catch (err) {
            console.error('Erro ao cadastrar:', err);
            alert('Erro ao cadastrar.');
        }
    };

    return (
        <div>
            <h2>Cadastrar Empreendedor</h2>
            <form onSubmit={handleSubmit}>
                <input name="nome" placeholder="Nome" onChange={handleChange} required />
                <input name="tipo_negocio" placeholder="Tipo de Negócio" onChange={handleChange} required />
                <input name="localizacao" placeholder="Localização" onChange={handleChange} required />
                <input name="contato" placeholder="Contato" onChange={handleChange} />
                <button type="submit">Cadastrar</button>
            </form>
        </div>
    );
}

export default SignUpUser;